import { render } from "./Course.vue?vue&type=template&id=5b8b42d1&scoped=true"
import script from "./Course.vue?vue&type=script&lang=js"
export * from "./Course.vue?vue&type=script&lang=js"

import "./Course.vue?vue&type=style&index=0&id=5b8b42d1&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b8b42d1"]])

export default __exports__